import React, { Fragment } from 'react';
import { ContractDataType } from './SummaryContractModal';
// import { Col, Form, Row } from 'react-bootstrap';
// import StopLightWithMessage from './StopLightWithMessage';
import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { ResumeChecklistProjectType } from './ResumeChecklistCellRenderer';
import SummaryInfoStatus from './SummaryInfoStatus';
import SummaryInfoList from './SummaryInfoList';

interface SummaryContractModalInfoProps {
	contractData: ContractDataType;
	project: ResumeChecklistProjectType;
}

const SummaryContractModalInfo: React.FC<SummaryContractModalInfoProps> = ({ contractData, project }) => {
	const items = [
		{
			label: 'Nome Fornitore',
			value: contractData.supplierName ?? 'N.D.',
		},
		{
			label: 'Codice Fornitore',
			value: contractData.supplierCode ?? 'N.D.',
		},
		{
			label: 'Partita Iva',
			value: contractData.vatNumber ?? 'N.D.',
		},
		{
			label: "Nr. Lettera D'Incarico",
			value: contractData?.po === false ? contractData?.number : 'N.D.',
		},
		{
			label: 'Nr. Attingimento',
			value: contractData?.po === true ? contractData?.number : 'N.D.',
		},
		{
			label: 'Data Documento',
			value: contractData?.date ? dateFormatter(contractData?.date) : 'N.D.',
		},
		{
			label: contractData?.project?.cupType === 'I' ? 'ID Progetto' : 'CUP',
			value: contractData?.project?.cup ?? 'N.D.',
		},
		...(project.streamConfigurationType === 'WP'
			? []
			: [
					{
						label: 'Nr. Procedura',
						value: contractData?.frameworkContract?.tender?.tenderNumber ?? 'N.D.',
					},
					{
						label: 'CIG',
						value:
							contractData.cigs?.map((cig) => (
								<Fragment key={cig.id}>
									{cig.cig}
									<br />
								</Fragment>
							)) ?? 'N.D.',
					},
				]),
		{
			label: 'Nr. Contratto Quadro',
			value: contractData?.po === true && contractData?.frameworkContract ? contractData?.frameworkContract.number : 'N.D.',
		},
		{
			label: 'Imponibile Consuntivato (€)',
			value: contractData?.baseAmount ? formatToDecimals(contractData.baseAmount) : 'N.D.',
		},
		{
			label: 'Avvio Progetto',
			value: contractData?.project?.startDate ? dateFormatter(contractData?.project?.startDate) : 'N.D.',
		},
	];
	return (
		<div className="summary_info-container">
			<SummaryInfoStatus entityLabel="Stato del contratto/attingimento" checklistColor={contractData.checkliststatus?.color} />

			<div>
				<h4>Dati contratto</h4>

				<SummaryInfoList items={items} />
			</div>
		</div>
		// <Form className="custom-entity_modal-info_form">
		// 	<Row style={{ marginBottom: '40px' }}>
		// 		<Col
		// 			style={{
		// 				backgroundColor: '#EDF0F7',
		// 				padding: '1rem',
		// 				borderRadius: '8px',
		// 				display: 'flex',
		// 				gap: '10px',
		// 				alignItems: 'center',
		// 				justifyContent: 'space-between',
		// 				paddingBlock: '18px',
		// 			}}
		// 		>
		// 			<p
		// 				style={{
		// 					marginTop: 'auto',
		// 					marginBottom: 0,
		// 					fontWeight: 700,
		// 					fontSize: '16px',
		// 				}}
		// 			>
		// 				Stato del contratto/attingimento
		// 			</p>
		// 			<div
		// 				style={{
		// 					marginBottom: 'auto',
		// 				}}
		// 			>
		// 				<StopLightWithMessage checklistColor={contractData.checkliststatus?.color} messageStyles={{ fontWeight: 500 }} />
		// 			</div>
		// 		</Col>
		// 	</Row>
		// 	<Row className="mt-3">
		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Nome Fornitore</Form.Label>
		// 			<Form.Text as="p">{contractData.supplierName ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Codice Fornitore</Form.Label>
		// 			<Form.Text as="p">{contractData.supplierCode ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Partita Iva</Form.Label>
		// 			<Form.Text as="p">{contractData.vatNumber ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Nr. Lettera D'Incarico</Form.Label>
		// 			<Form.Text as="p">{contractData?.po === false ? contractData?.number : 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Nr. Attingimento</Form.Label>
		// 			<Form.Text as="p">{contractData?.po === true ? contractData?.number : 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Data Documento</Form.Label>
		// 			<Form.Text as="p">{contractData?.date ? dateFormatter(contractData?.date) : 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem" style={{ overflowWrap: 'break-word' }}>
		// 			<Form.Label className="mb-3">{contractData?.project?.cupType === 'I' ? 'ID Progetto' : 'CUP'}</Form.Label>
		// 			<Form.Text as="p">{contractData?.project?.cup ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		{project.streamConfigurationType === 'WP' ? null : (
		// 			<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 				<Form.Label className="mb-3">Nr. Procedura</Form.Label>
		// 				<Form.Text as="p">{contractData?.frameworkContract?.tender?.tenderNumber ?? 'N.D.'}</Form.Text>
		// 			</Form.Group>
		// 		)}

		// 		{project.streamConfigurationType === 'WP' ? null : (
		// 			<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 				<Form.Label className="mb-3">CIG</Form.Label>
		// 				<Form.Text as="p">
		// 					{contractData.cigs?.map((cig) => (
		// 						<Fragment key={cig.id}>
		// 							{cig.cig}
		// 							<br />
		// 						</Fragment>
		// 					)) ?? 'N.D.'}
		// 				</Form.Text>
		// 			</Form.Group>
		// 		)}

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Nr. Contratto Quadro</Form.Label>
		// 			<Form.Text as="p">
		// 				{contractData?.po === true && contractData?.frameworkContract ? contractData?.frameworkContract.number : 'N.D.'}
		// 			</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Imponibile Consuntivato (€)</Form.Label>
		// 			<Form.Text as="p">{contractData?.baseAmount ? formatToDecimals(contractData.baseAmount) : 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col} className="col-4 px-4 mb-2rem">
		// 			<Form.Label className="mb-3">Avvio Progetto</Form.Label>
		// 			<Form.Text as="p">{contractData?.project?.startDate ? dateFormatter(contractData?.project?.startDate) : 'N.D.'}</Form.Text>
		// 		</Form.Group>
		// 	</Row>
		// </Form>
	);
};

export default SummaryContractModalInfo;
